import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'], // Corrected from styleUrl to styleUrls
  standalone: true,
})

export class SidebarComponent implements OnInit {
  isCollapsed: boolean = false
  currentUrl: string = window.location.pathname;
  cardAllowed: any = sessionStorage.getItem('cardAllowed');
  constructor(iconRegistry: MatIconRegistry, public cdr: ChangeDetectorRef, public router: Router,
    sanitizer: DomSanitizer,
  ) {
    iconRegistry.addSvgIcon(
      'epin_blue_logo',
      sanitizer.bypassSecurityTrustResourceUrl('assets/ePIN/epin_blue_logo.svg')
    );
    iconRegistry.addSvgIcon(
      'epin_blue_fav',
      sanitizer.bypassSecurityTrustResourceUrl('assets/ePIN/epin_blue_fav.svg')
    )
  }


  ngOnInit(): void {
    console.log('Current URL:', this.currentUrl);
    if (this.isMobile() || this.isTablet()) {
      this.isCollapsed = true
    }

    this.router.events.subscribe(() => {
      if (window.location.pathname.includes('transactions')) {
        this.currentUrl = window.location.pathname;
        this.cdr.detectChanges();
      }
    });
  }


  isMobile(): boolean {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const byUa = /Mobi|Android.*Mobile|iPhone|BlackBerry|BB10|IEMobile|Opera Mini/i.test(ua);
    const byWidth = typeof window !== 'undefined' && window.innerWidth <= 600;
    return byUa || byWidth;
  }

  isTablet(): boolean {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const byUa = /Tablet|iPad|Nexus 7|Kindle|Silk|PlayBook/i.test(ua);
    const byWidth = typeof window !== 'undefined' && window.innerWidth > 600 && window.innerWidth <= 1024;
    return byUa || byWidth;
  }

  isTouchDevice(): boolean {
    return (typeof window !== 'undefined' && ('ontouchstart' in window || (navigator && navigator.maxTouchPoints > 0)));
  }

  watchResize(callback: () => void): () => void {
    if (typeof window === 'undefined') return () => { };
    const handler = () => callback();
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }


}
